// src/components/Footer.jsx
import React from "react";

export default function Footer() {
  return (
    <div className="rts-footer-one footer-bg-two">
      <div className="container">
        <div className="row pt--90 pb--55 pb_sm--40">
          <div className="col-lg-12">
            <div className="single-footer-one-wrapper two">
              {/* First Component */}
              <div className="single-footer-component first">
                <a href="/" className="logo-area-footer">
                  <img
                    src="/assets/images/logo/white-logo.png"
                    alt=" Cauvery Tours Logo"
                  />
                </a>
                <div className="body mt--45">
                  <p className="disc">
                    Our tour packages are customized to make your holidays a memorable celebration. We plan the tours in a way that each destination gets its due share of your valuable time.

                  </p>
                  <div className="rts-social-style-one">
                    <ul>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Useful Links */}
              <div className="single-footer-component">
                <div className="title-area">
                  <h5 className="title">Useful Links</h5>
                </div>
                <div className="body">
                  <div className="pages-footer">
                    <ul>
                      <li>
                        <a href="/#home">
                          <i className="fa-regular fa-chevron-right"></i>
                          <p>Home</p>
                        </a>
                      </li>
                      <li>
                        <a href="/#about">
                          <i className="fa-regular fa-chevron-right"></i>
                          <p>About Us</p>
                        </a>
                      </li>
                      <li>
                        <a href="/#services">
                          <i className="fa-regular fa-chevron-right"></i>
                          <p>Services</p>
                        </a>
                      </li>
                   <li>
  <a
    href="https://g.page/r/CT8wmIV5z8kvEAI/review"
    target="_blank"
    rel="noopener noreferrer"
  >
    <i className="fa-regular fa-chevron-right"></i>
    <p>Post Review</p>
  </a>
</li>


                      <li>
                        <a href="https://mail.hostinger.com">
                          <i className="fa-regular fa-chevron-right"></i>
                          <p>Mail account</p>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>


                {/* Contact Info */}
              <div className="single-footer-component last">
                <div className="title-area">
                  <h5 className="title">Contact Us</h5>
                </div>
                <div className="body">
                  <div className="footer-contact-wrapper-2">
                    {/* Phone */}
                    <div className="contact-single">
                      <div className="icon">{/* Add phone SVG here */}</div>
                      <div className="info-content ml-dec-5">
                        <a href="tel:+919842421862">
                          <h6 className="title">+91 9894148948</h6>
                        
                        </a>
                        <span>Call us for support</span>
                      </div>
                    </div>

                    {/* Email */}
                    <div className="contact-single">
                      <div className="icon">{/* Add email SVG here */}</div>
                      <div className="info-content">
                        <a href="mailto:info@cauverytours.com">
                          <h6 className="title">info@cauverytours.com</h6>
                        </a>
                        <span>Email us for query</span>
                      </div>
                    </div>

                  
                  </div>
                </div>
              </div>

              {/* Contact Info */}
              <div className="single-footer-component last">
                <div className="title-area">
                  <h5 className="title">Address</h5>
                </div>
                <div className="body">
                  <div className="footer-contact-wrapper-2">
         

           

                    {/* Address */}
                    <div className="contact-single">
                      <div className="icon">{/* Add location SVG here */}</div>
                      <div className="info-content">
                        <a href="#">
                          <h6 className="title">
                           No 131 Bharathiyar Road , Ground Floor (Opposite Perumal Kovil), Karaikal
                          </h6>
                        </a>
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="row pb--20 pt--20 border-top-copyright">
          <div className="col-lg-12">
            <div className="copyright-area-two">
              <div className="left">
                <p>Copyright 2025. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
